import React, { useState } from 'react';
import VALID_USERS from '../constants/users';
import STALLS from '../data/stalls';
import logo from '../logo.png';

function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr('');
    await new Promise((r) => setTimeout(r, 800));
    if (VALID_USERS[email.toLowerCase()] === pass) {
      const rawName = email.split('@')[0];
      const name = rawName.charAt(0).toUpperCase() + rawName.slice(1);
      onLogin({ email: email.toLowerCase(), name });
    } else {
      setErr('Invalid email or password. Please try again.');
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    background: '#f7f7f7',
    border: '1px solid #e0e0e0',
    borderRadius: 10,
    padding: '14px 16px',
    color: '#1a1a1a',
    fontSize: 14,
    outline: 'none',
    transition: 'border 0.2s',
  };

  const labelStyle = {
    fontSize: 11,
    letterSpacing: 2,
    textTransform: 'uppercase',
    color: 'rgba(0,0,0,0.4)',
    display: 'block',
    marginBottom: 8,
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#ffffff',
        display: 'flex',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background glow */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage:
            'radial-gradient(ellipse 80% 60% at 20% 40%, rgba(91,79,207,0.04) 0%, transparent 60%), radial-gradient(ellipse 60% 80% at 80% 80%, rgba(196,144,58,0.03) 0%, transparent 60%)',
        }}
      />

      {/* Decorative rings */}
      <div
        style={{
          position: 'absolute',
          top: '10%',
          right: '8%',
          width: 400,
          height: 400,
          borderRadius: '50%',
          border: '1px solid rgba(0,0,0,0.04)',
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '20%',
          right: '12%',
          width: 240,
          height: 240,
          borderRadius: '50%',
          border: '1px solid rgba(0,0,0,0.05)',
          pointerEvents: 'none',
        }}
      />

      {/* Left: Login Form */}
      <div
        style={{
          width: '50%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '2rem 5rem',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Logo */}
        <div style={{ marginBottom: '1.5rem' }}>
          <img src={logo} alt="ChalkWalk Design Studio" style={{ width: 260, height: 'auto', objectFit: 'contain', display: 'block', marginBottom: 20, marginLeft: -24 }} />
          <p style={{ color: 'rgba(0,0,0,0.45)', fontSize: 15, lineHeight: 1.6 }}>
            Representative portal for exhibition design and stall selection.
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handle} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {err && (
            <div
              style={{
                background: 'rgba(196,75,43,0.08)',
                border: '1px solid rgba(196,75,43,0.2)',
                borderRadius: 8,
                padding: '12px 16px',
                color: '#c44b2b',
                fontSize: 13,
              }}
            >
              {err}
            </div>
          )}

          <div>
            <label style={labelStyle}>Email Address</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="you@chalkwalkconsulting.com"
              required
              style={inputStyle}
              onFocus={(e) => (e.target.style.borderColor = '#5B4FCF')}
              onBlur={(e) => (e.target.style.borderColor = '#e0e0e0')}
            />
          </div>

          <div>
            <label style={labelStyle}>Password</label>
            <div style={{ position: 'relative' }}>
              <input
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                type={showPass ? 'text' : 'password'}
                placeholder="••••••••••"
                required
                style={{ ...inputStyle, paddingRight: 60 }}
                onFocus={(e) => (e.target.style.borderColor = '#5B4FCF')}
                onBlur={(e) => (e.target.style.borderColor = '#e0e0e0')}
              />
              <button
                type="button"
                onClick={() => setShowPass(!showPass)}
                style={{
                  position: 'absolute',
                  right: 14,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  color: 'rgba(0,0,0,0.35)',
                  fontSize: 13,
                  cursor: 'pointer',
                }}
              >
                {showPass ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            onMouseEnter={(e) => { if (!loading) e.target.style.background = '#b91c1c'; e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 6px 20px rgba(220,38,38,0.4)'; }}
            onMouseLeave={(e) => { e.target.style.background = loading ? 'rgba(220,38,38,0.5)' : '#dc2626'; e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = 'none'; }}
            style={{
              marginTop: 8,
              background: loading ? 'rgba(220,38,38,0.5)' : '#dc2626',
              border: 'none',
              borderRadius: 10,
              padding: '15px',
              color: '#fff',
              fontSize: 14,
              fontWeight: 500,
              letterSpacing: 0.5,
              transition: 'all 0.2s',
              cursor: loading ? 'not-allowed' : 'pointer',
            }}
          >
            {loading ? 'Signing in…' : 'Sign In →'}
          </button>
        </form>

        <div
          style={{
            marginTop: '3rem',
            paddingTop: '2rem',
            borderTop: '1px solid rgba(0,0,0,0.07)',
          }}
        >
          <p style={{ fontSize: 12, color: 'rgba(0,0,0,0.3)' }}>
            © 2025 ChalkWalk Consulting. All rights reserved.
          </p>
        </div>
      </div>

      {/* Right: Showcase */}
      <div
        style={{
          width: '50%',
          position: 'relative',
          overflow: 'hidden',
          background: '#111',
        }}
      >
        {/* Mosaic layout */}
        <div style={{ position: 'absolute', inset: 0, display: 'grid', gridTemplateColumns: '1.2fr 0.8fr', gridTemplateRows: '1fr 1fr', gap: 3 }}>
          {/* Large left image spanning full height */}
          <div style={{ gridRow: '1 / 3', position: 'relative', overflow: 'hidden' }}>
            <img src={STALLS[0].images[0]} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', transform: 'scale(1.05)', transition: 'transform 8s ease' }} />
          </div>
          {/* Top right */}
          <div style={{ position: 'relative', overflow: 'hidden' }}>
            <img src={STALLS[1].images[0]} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          {/* Bottom right */}
          <div style={{ position: 'relative', overflow: 'hidden' }}>
            <img src={STALLS[2].images[0]} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
        </div>

        {/* Overlays */}
        {/* Base dark tint over entire panel */}
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.25)' }} />
        {/* Diagonal colour wash — dark to subtle purple */}
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(0,0,0,0.10) 0%, transparent 45%, rgba(91,79,207,0.12) 100%)' }} />
        {/* Bottom fade so text stays readable */}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '55%', background: 'linear-gradient(transparent, rgba(0,0,0,0.70))' }} />
        {/* Top-left vignette */}
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 0% 0%, rgba(0,0,0,0.25) 0%, transparent 60%)' }} />

        {/* Top badge */}
        <div style={{ position: 'absolute', top: 32, left: 32, zIndex: 2 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(255,255,255,0.12)', backdropFilter: 'blur(10px)', borderRadius: 30, padding: '6px 14px', border: '1px solid rgba(255,255,255,0.2)' }}>
            <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#4ade80', boxShadow: '0 0 6px #4ade80' }} />
            <span style={{ fontSize: 11, color: '#fff', letterSpacing: 2, textTransform: 'uppercase' }}>Live Portfolio</span>
          </div>
        </div>

        {/* Bottom content */}
        <div style={{ position: 'absolute', bottom: 40, left: 36, right: 36, zIndex: 2 }}>
          <div style={{ fontSize: 13, letterSpacing: 3, textTransform: 'uppercase', color: '#fff', fontWeight: 600, marginBottom: 10 }}>ChalkWalk Consulting</div>
          <div style={{ fontFamily: 'DM Serif Display', fontSize: 34, color: '#fff', lineHeight: 1.2, marginBottom: 16 }}>
            Exhibition Stalls<br />
            <span style={{ fontStyle: 'italic', color: '#fff' }}>Crafted to Impress</span>
          </div>
          {/* Stall count pills */}
          <div style={{ display: 'flex', gap: 8 }}>
            {['75 Designs', 'Premium', 'All Sizes'].map((tag) => (
              <span key={tag} style={{ fontSize: 11, background: 'rgba(255,255,255,0.12)', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 20, padding: '4px 12px', color: 'rgba(255,255,255,0.85)', letterSpacing: 0.5 }}>{tag}</span>
            ))}
          </div>
        </div>

        {/* Side thumbnail strip */}
        <div style={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)', zIndex: 2, display: 'flex', flexDirection: 'column', gap: 6 }}>
          {STALLS.slice(3, 6).map((s, i) => (
            <div key={i} style={{ width: 48, height: 48, borderRadius: 8, overflow: 'hidden', border: '2px solid rgba(255,255,255,0.3)', boxShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
              <img src={s.images[0]} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
